import {ReactLocalStorage} from "../utils/ReactLocalStorage";
import createStorageHook from "./createStorageHook";

const useLocalStorage = createStorageHook(ReactLocalStorage, {
    customEventName: "localStorageChange", // allows for same tab storage sync
    useWindowStorageEvent: false, // allows for another tab storage sync
});

export default useLocalStorage;
